// extracted by mini-css-extract-plugin
module.exports = {"saved-items":"style_saved-items__23duH","saved-label":"style_saved-label__uTR1c"};